














import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({

    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.diningRoom.surface",
        };
    },
    computed: {
        floorAreaDiningRoom: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore) ?? "";
        },
        hasDiningRoom: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.diningRoom.exists");
        }
    },
    methods: {
        updateValue: function(floorAreaDiningRoom: number): void {
            if (!this.hasDiningRoom|| (floorAreaDiningRoom == 0 && this.floorAreaDiningRoom != null)) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": floorAreaDiningRoom});
            }
        }
    }
});

